export default __webpack_public_path__ + "static/media/839.d0613321.png";